/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/input/style/index';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/button/style/index';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'TSearchInput'
  },
  __name: 'TSearchInput',
  props: {
    modelValue: {},
    label: {},
    placeholder: {},
    allowEmpty: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "request-search"],
  setup(__props, {
    emit: __emit
  }) {
    /**
     * 基于 el-input 的封装
     * request-search 方法会在用户点按回车或者用户点击搜索按钮时触发，但如果用户输入空格，则不会触发
     * 当用户触发搜或者 input 框发生 blur，组件会对绑定的 model 值进行 trim 操作
     * 该组件会透传所有 el-input 相关的属性
     */
    const emit = __emit;
    const props = __props;
    const {
      modelValue
    } = toRefs(props);
    const checkModelValue = () => {
      if (typeof modelValue.value === 'string') {
        const trimmedValue = modelValue.value.trim();
        emit('update:modelValue', trimmedValue);
        return trimmedValue;
      }
    };
    const handleRequestSearch = () => {
      const searchValue = checkModelValue();
      if (searchValue || props.allowEmpty) {
        emit('request-search', searchValue);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_input, _mergeProps({
        "model-value": _unref(modelValue),
        placeholder: _ctx.placeholder
      }, _ctx.$attrs, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        onKeyup: _withKeys(handleRequestSearch, ["enter"]),
        onBlur: checkModelValue
      }), _createSlots({
        append: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "t-icon-search",
          onClick: handleRequestSearch
        })]),
        _: 2
      }, [_ctx.label ? {
        name: "prepend",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.label), 1)]),
        key: "0"
      } : undefined]), 1040, ["model-value", "placeholder"]);
    };
  }
});